webpackJsonp([1],{

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(256);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  // login page
  getContact: function getContact(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'v2/checkin/contact', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  Login: function Login(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'v2/authen/login', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  OAuth: function OAuth(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'v2/authen/oauth', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },

  // checkin page
  getAreaList: function getAreaList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'v2/checkin/arealist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRecentCheckin: function getRecentCheckin(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'v2/checkin/recentcheckin', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addCheckin: function addCheckin(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'v2/checkin/addcheckin', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_index_css__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_mixin__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_oauth__ = __webpack_require__(378);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBQsgo6QKEwuNAXm2NvxTOOiluvw0N2Gss',
    libraries: 'places'
  },
  installComponents: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */],
  template: '<App/>',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d721a3a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(232);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d721a3a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Checkin__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Loading__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Error__ = __webpack_require__(344);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var titlename = ' | RMUTL Check-In';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    name: 'loading',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Loading__["a" /* default */],
    meta: { title: 'Loading', title_sub: 'Loading' }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["a" /* default */],
    meta: { title: 'Login', title_sub: 'Login' }
  }, {
    path: '/checkin',
    name: 'checkin',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Checkin__["a" /* default */],
    meta: { title: 'Check-In', title_sub: 'Check-In' }
  }, {
    path: '/error',
    name: 'error',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Error__["a" /* default */],
    meta: { title: 'Error', title_sub: 'Error' }
  }]
});
var DEFAULT_TITLE = titlename;
router.afterEach(function (to, from) {
  document.title = to.meta.title_sub !== '' ? to.meta.title_sub + titlename : to.meta.title + titlename || DEFAULT_TITLE + titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75af321e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75af321e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75af321e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-container d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"main-container card-body"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"form-login"}},[_c('div',{staticClass:"m-b-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control form-input-bg",attrs:{"type":"text","id":"tb-rfname","placeholder":"username","autocomplete":"off","required":""},domProps:{"value":(_vm.username)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n            Username is required\n          ")])]),_vm._v(" "),_c('div',{staticClass:"m-b-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control form-input-bg",attrs:{"type":"password","id":"tb-rfpwd","placeholder":"password","autocomplete":"off","required":""},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n            Password is required\n          ")])]),_vm._v(" "),_c('div',{staticClass:"d-grid gap-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.checkForm}},[_c('svg',{staticClass:"icon",staticStyle:{"margin-top":"-4px !important"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 8v-2a2 2 0 0 1 2 -2h2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 16v2a2 2 0 0 0 2 2h2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 4h2a2 2 0 0 1 2 2v2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 20h2a2 2 0 0 0 2 -2v-2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"8","y":"11","width":"8","height":"5","rx":"1"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10 11v-2a2 2 0 1 1 4 0v2"}})]),_vm._v("\n            เข้าสู่ระบบ\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"note-container text-12 m-t-15",domProps:{"innerHTML":_vm._s(_vm.contact.description)}}),_vm._v(" "),_c('div',{staticClass:"credit-container text-center text-mute text-10 m-t-10"},[_vm._v("\n        พัฒนาโดย"+_vm._s(_vm.contact.team_develop)),_c('br'),_vm._v("\n        อัพเดทล่าสุด "+_vm._s(_vm.dateTimeFormat(_vm.last_update))),_c('br'),_vm._v("\n        ระบบปฏิบัติการ "+_vm._s(_vm.appCode)+"\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-container text-center"},[_c('img',{staticClass:"m-3",attrs:{"src":__webpack_require__(260),"alt":"logo","width":"100"}}),_vm._v(" "),_c('h4',{},[_vm._v("RMUTL Check-In")]),_vm._v(" "),_c('h5',{staticClass:"text-mute text-12 m-b-15"},[_vm._v("เข้าระบบโดย Account มทร.ล้านนา")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-rmutl2.a563bde.png";

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkin_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2f1ea6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkin_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f2f1ea6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2f1ea6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_barcodeView_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d651ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_barcodeView_vue__ = __webpack_require__(339);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_barcodeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d651ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_barcodeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('barcode',{attrs:{"value":this.id_card,"format":"CODE128","displayValue":"false","textAlign":"center","height":"70"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('GmapMap',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{ lat: _vm.center.lat, lng: _vm.center.long },"zoom":_vm.zoom,"options":{
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      gestureHandling: 'greedy'
    }}},[_c('GmapMarker',{attrs:{"position":{ lat: _vm.location.lat, lng: _vm.location.long },"clickable":false,"draggable":false}}),_vm._v(" "),_vm._l((_vm.area_list),function(area){return _c('GmapCircle',{key:area.area_id,attrs:{"center":{
        lat: parseFloat(area.area_lat),
        lng: parseFloat(area.area_long)
      },"radius":parseInt(area.area_limit),"visible":true,"options":{
  fillColor: area.rad_color,
  fillOpacity: 0.3,
  strokeWeight: 0
}}})})],2),_vm._v(" "),_c('div',{staticClass:"top-container"},[_c('div',{staticClass:"profile-box"},[_c('div',{staticClass:"profile-image"},[_c('img',{attrs:{"src":_vm.user.image || '/static/img/nouser.jpg',"onerror":"this.src='/static/img/nouser.jpg'"}})]),_vm._v(" "),_c('div',{staticClass:"profile-detail"},[_c('div',{staticClass:"fullname"},[_vm._v(_vm._s(_vm.user.fullname))]),_vm._v(" "),_c('small',{staticClass:"position text-mute"},[_vm._v("ตำแหน่ง: "+_vm._s(_vm.user.position))])])])]),_vm._v(" "),_c('div',{staticClass:"bottom-container"},[_c('div',{staticClass:"action-box"},[_c('button',{staticClass:"btn btn-success action-btn m-r-5",on:{"click":function($event){return _vm.reLoad()}}},[_c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success action-btn m-r-5",on:{"click":function($event){return _vm.reCenter()}}},[_c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"12","r":"3"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"12","r":"8"}}),_vm._v(" "),_c('line',{attrs:{"x1":"12","y1":"2","x2":"12","y2":"4"}}),_vm._v(" "),_c('line',{attrs:{"x1":"12","y1":"20","x2":"12","y2":"22"}}),_vm._v(" "),_c('line',{attrs:{"x1":"20","y1":"12","x2":"22","y2":"12"}}),_vm._v(" "),_c('line',{attrs:{"x1":"2","y1":"12","x2":"4","y2":"12"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success action-btn",attrs:{"disabled":_vm.user.card_id === ''},on:{"click":function($event){return _vm.cardGenerator()}}},[_c('svg',{staticClass:"icon icon-tabler icon-tabler-id",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"4","width":"18","height":"16","rx":"3"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"9","cy":"10","r":"2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"15","y1":"8","x2":"17","y2":"8"}}),_vm._v(" "),_c('line',{attrs:{"x1":"15","y1":"12","x2":"17","y2":"12"}}),_vm._v(" "),_c('line',{attrs:{"x1":"7","y1":"16","x2":"17","y2":"16"}})])])]),_vm._v(" "),_c('div',{staticClass:"detail-box"},[_c('div',{staticClass:"location-box"},[_c('div',{staticClass:"location-show"},[_c('small',{staticClass:"text-mute"},[_vm._v("จุดลงเวลา")]),_vm._v(" "),_c('div',[_c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 30 30","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"11","r":"3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"}})]),_vm._v("\n              "+_vm._s(_vm.area_use_name)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"location-switch text-right"},[_c('small',{staticClass:"text-mute",staticStyle:{"text-align":"right"}},[_vm._v("ตัวเลือกจุดลงเวลา")]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.switchType()}}},[(_vm.type === 1)?_c('svg',{staticClass:"icon",staticStyle:{"margin-top":"-5px !important"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('rect',{attrs:{"x":"4","y":"4","width":"16","height":"16","rx":"2"}})]):_vm._e(),_vm._v(" "),(_vm.type === 2)?_c('svg',{staticClass:"icon",staticStyle:{"margin-top":"-5px !important"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('rect',{attrs:{"x":"4","y":"4","width":"16","height":"16","rx":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 12l2 2l4 -4"}})]):_vm._e(),_vm._v("\n              ปฏิบัติงานที่บ้าน\n            ")])])]),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"text-mute"},[_vm._v("ลงเวลาล่าสุด")]),_vm._v(" "),_c('ul',{staticClass:"checkin-list"},_vm._l((_vm.recent_checkin),function(row,index){return _c('li',{key:index},[_c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 30 30","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9"}}),_vm._v(" "),_c('polyline',{attrs:{"points":"12 7 12 12 15 15"}})]),_vm._v("\n              "+_vm._s(row.datetime)+" - "+_vm._s(row.area_name)+"\n            ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"checkin-box"},[_c('button',{staticClass:"btn btn-success btn-lg w-100",attrs:{"disabled":_vm.is_allow === false || _vm.$store.state.is_loading === true},on:{"click":function($event){return _vm.checkIn()}}},[_c('svg',{staticClass:"icon",staticStyle:{"margin-top":"-6px !important"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 14v4h4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 11v-4a2 2 0 0 0 -2 -2h-2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"8","y":"3","width":"6","height":"4","rx":"2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"18","cy":"18","r":"4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 11h4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 15h3"}})]),_vm._v("\n          "+_vm._s(_vm.text_checkin)+"\n        ")])])]),_vm._v(" "),_c('modal',{attrs:{"name":"card_modal","resizable":true,"width":"95%","height":"auto"}},[_c('div',{staticClass:"card_container"},[_c('div',{staticClass:"card_title"},[_c('h4',[_vm._v("บัตรยืนยันตัวตน RMUTL Account")])]),_vm._v(" "),_c('div',{staticClass:"card_body m-b-10"},[_c('div',{staticClass:"m-b-5"},[_c('h5',[_vm._v(_vm._s(_vm.user.fullname))]),_vm._v(" "),_c('h5',[_vm._v("RMUTL ID "+_vm._s(_vm.user.card_id))])]),_vm._v(" "),_c('div',{staticClass:"m-b-5"},[_c('barcodeView',{attrs:{"id_card":_vm.user.card_id}})],1)]),_vm._v(" "),_c('div',{staticClass:"card_footer"},[_c('button',{staticClass:"btn btn-outline-secondary btn-lg w-100",on:{"click":function($event){return _vm.$modal.hide('card_modal')}}},[_vm._v("\n            ปิดหน้านี้\n          ")])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"alert_modal","resizable":true,"width":"95%","height":"auto"}},[_c('div',{staticClass:"card_container"},[_c('div',{staticClass:"card_title"},[_c('h4',[_vm._v("การแจ้งเตือน")])]),_vm._v(" "),_c('div',{staticClass:"card_body m-b-10"},[_c('div',{staticClass:"m-b-5 text-start"},[_c('div',[_vm._v(" เว็บไซต์ระบบ CheckIn RMUTL บนระบบปฏิบัติการ Android จะปิดให้บริการหลังจากวันที่ 30 กันยายน 2566")]),_vm._v(" "),_c('div',[_vm._v(" ท่านสามารถใช้งานระบบ CheckIn RMUTL ผ่านทางแอพพลิเคชั่น RMUTL CheckIn สามารถดาวน์โหลดได้ที่ลิงค์ด้านล่าง")])])]),_vm._v(" "),_c('div',{staticClass:"card_footer"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca6179_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ca6179"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca6179_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 342:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-container d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"main-container card-body"},[_c('div',{staticClass:"head-container text-center"},[_c('img',{attrs:{"src":__webpack_require__(82),"width":"120"}}),_vm._v(" "),_c('h4',{staticClass:"m-t-15"},[_vm._v("Loading ...")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_335d8699_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(346);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-335d8699"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_335d8699_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-container d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"main-container card-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-grid gap-2 m-t-20"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.goLogin()}}},[_c('svg',{staticClass:"icon",staticStyle:{"margin-top":"-4px !important"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16.3 5h.7a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h5l-2.82 -2.82m0 5.64l2.82 -2.82","transform":"rotate(-45 12 12)"}})]),_vm._v("\n          ตรวจสอบอีกครั้ง\n        ")])]),_vm._v(" "),_c('div',{staticClass:"note-container text-12 m-t-20",domProps:{"innerHTML":_vm._s(_vm.contact.description)}}),_vm._v(" "),_c('div',{staticClass:"credit-container text-center text-mute text-10 m-t-10",on:{"click":function($event){return _vm.showDeviceInfo()}}},[_vm._v("\n        พัฒนาโดย"+_vm._s(_vm.contact.team_develop)),_c('br'),_vm._v("\n        อัพเดทล่าสุด "+_vm._s(_vm.dateTimeFormat(_vm.last_update))+"\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_device_info === 2),expression:"show_device_info === 2"}],staticClass:"info-container m-t-10 text-start text-10"},[_c('pre',[_vm._v(_vm._s(_vm.device_info))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-container text-center"},[_c('img',{attrs:{"src":__webpack_require__(82),"width":"120"}}),_vm._v(" "),_c('h4',{staticClass:"m-t-15"},[_vm._v("ไม่สามารถใช้งานบนอุปกรณ์นี้ได้")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_json__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_config_json__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  config: {},
  public_token: __WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.public_token,
  is_loading: false,
  api_url: __WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.api_url,
  ui_url: __WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.ui_url,
  screen_height: 0,
  screen_width: 0,
  footer_show: true,
  header_show: true
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(86);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(359);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(87);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(89);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(367);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(369);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(92);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(372);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_config_json__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_config_json__);


var moment = __webpack_require__(0);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      title_web: __WEBPACK_IMPORTED_MODULE_1__static_config_json___default.a.title_web,
      description_web: __WEBPACK_IMPORTED_MODULE_1__static_config_json___default.a.description_web,
      last_update: __WEBPACK_IMPORTED_MODULE_1__static_config_json___default.a.last_update
    };
  },

  methods: {
    dateTimeFormat: function dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
  }
});

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 93,
	"./af.js": 93,
	"./ar": 94,
	"./ar-dz": 95,
	"./ar-dz.js": 95,
	"./ar-kw": 96,
	"./ar-kw.js": 96,
	"./ar-ly": 97,
	"./ar-ly.js": 97,
	"./ar-ma": 98,
	"./ar-ma.js": 98,
	"./ar-sa": 99,
	"./ar-sa.js": 99,
	"./ar-tn": 100,
	"./ar-tn.js": 100,
	"./ar.js": 94,
	"./az": 101,
	"./az.js": 101,
	"./be": 102,
	"./be.js": 102,
	"./bg": 103,
	"./bg.js": 103,
	"./bm": 104,
	"./bm.js": 104,
	"./bn": 105,
	"./bn-bd": 106,
	"./bn-bd.js": 106,
	"./bn.js": 105,
	"./bo": 107,
	"./bo.js": 107,
	"./br": 108,
	"./br.js": 108,
	"./bs": 109,
	"./bs.js": 109,
	"./ca": 110,
	"./ca.js": 110,
	"./cs": 111,
	"./cs.js": 111,
	"./cv": 112,
	"./cv.js": 112,
	"./cy": 113,
	"./cy.js": 113,
	"./da": 114,
	"./da.js": 114,
	"./de": 115,
	"./de-at": 116,
	"./de-at.js": 116,
	"./de-ch": 117,
	"./de-ch.js": 117,
	"./de.js": 115,
	"./dv": 118,
	"./dv.js": 118,
	"./el": 119,
	"./el.js": 119,
	"./en-au": 120,
	"./en-au.js": 120,
	"./en-ca": 121,
	"./en-ca.js": 121,
	"./en-gb": 122,
	"./en-gb.js": 122,
	"./en-ie": 123,
	"./en-ie.js": 123,
	"./en-il": 124,
	"./en-il.js": 124,
	"./en-in": 125,
	"./en-in.js": 125,
	"./en-nz": 126,
	"./en-nz.js": 126,
	"./en-sg": 127,
	"./en-sg.js": 127,
	"./eo": 128,
	"./eo.js": 128,
	"./es": 129,
	"./es-do": 130,
	"./es-do.js": 130,
	"./es-mx": 131,
	"./es-mx.js": 131,
	"./es-us": 132,
	"./es-us.js": 132,
	"./es.js": 129,
	"./et": 133,
	"./et.js": 133,
	"./eu": 134,
	"./eu.js": 134,
	"./fa": 135,
	"./fa.js": 135,
	"./fi": 136,
	"./fi.js": 136,
	"./fil": 137,
	"./fil.js": 137,
	"./fo": 138,
	"./fo.js": 138,
	"./fr": 139,
	"./fr-ca": 140,
	"./fr-ca.js": 140,
	"./fr-ch": 141,
	"./fr-ch.js": 141,
	"./fr.js": 139,
	"./fy": 142,
	"./fy.js": 142,
	"./ga": 143,
	"./ga.js": 143,
	"./gd": 144,
	"./gd.js": 144,
	"./gl": 145,
	"./gl.js": 145,
	"./gom-deva": 146,
	"./gom-deva.js": 146,
	"./gom-latn": 147,
	"./gom-latn.js": 147,
	"./gu": 148,
	"./gu.js": 148,
	"./he": 149,
	"./he.js": 149,
	"./hi": 150,
	"./hi.js": 150,
	"./hr": 151,
	"./hr.js": 151,
	"./hu": 152,
	"./hu.js": 152,
	"./hy-am": 153,
	"./hy-am.js": 153,
	"./id": 154,
	"./id.js": 154,
	"./is": 155,
	"./is.js": 155,
	"./it": 156,
	"./it-ch": 157,
	"./it-ch.js": 157,
	"./it.js": 156,
	"./ja": 158,
	"./ja.js": 158,
	"./jv": 159,
	"./jv.js": 159,
	"./ka": 160,
	"./ka.js": 160,
	"./kk": 161,
	"./kk.js": 161,
	"./km": 162,
	"./km.js": 162,
	"./kn": 163,
	"./kn.js": 163,
	"./ko": 164,
	"./ko.js": 164,
	"./ku": 165,
	"./ku.js": 165,
	"./ky": 166,
	"./ky.js": 166,
	"./lb": 167,
	"./lb.js": 167,
	"./lo": 168,
	"./lo.js": 168,
	"./lt": 169,
	"./lt.js": 169,
	"./lv": 170,
	"./lv.js": 170,
	"./me": 171,
	"./me.js": 171,
	"./mi": 172,
	"./mi.js": 172,
	"./mk": 173,
	"./mk.js": 173,
	"./ml": 174,
	"./ml.js": 174,
	"./mn": 175,
	"./mn.js": 175,
	"./mr": 176,
	"./mr.js": 176,
	"./ms": 177,
	"./ms-my": 178,
	"./ms-my.js": 178,
	"./ms.js": 177,
	"./mt": 179,
	"./mt.js": 179,
	"./my": 180,
	"./my.js": 180,
	"./nb": 181,
	"./nb.js": 181,
	"./ne": 182,
	"./ne.js": 182,
	"./nl": 183,
	"./nl-be": 184,
	"./nl-be.js": 184,
	"./nl.js": 183,
	"./nn": 185,
	"./nn.js": 185,
	"./oc-lnc": 186,
	"./oc-lnc.js": 186,
	"./pa-in": 187,
	"./pa-in.js": 187,
	"./pl": 188,
	"./pl.js": 188,
	"./pt": 189,
	"./pt-br": 190,
	"./pt-br.js": 190,
	"./pt.js": 189,
	"./ro": 191,
	"./ro.js": 191,
	"./ru": 192,
	"./ru.js": 192,
	"./sd": 193,
	"./sd.js": 193,
	"./se": 194,
	"./se.js": 194,
	"./si": 195,
	"./si.js": 195,
	"./sk": 196,
	"./sk.js": 196,
	"./sl": 197,
	"./sl.js": 197,
	"./sq": 198,
	"./sq.js": 198,
	"./sr": 199,
	"./sr-cyrl": 200,
	"./sr-cyrl.js": 200,
	"./sr.js": 199,
	"./ss": 201,
	"./ss.js": 201,
	"./sv": 202,
	"./sv.js": 202,
	"./sw": 203,
	"./sw.js": 203,
	"./ta": 204,
	"./ta.js": 204,
	"./te": 205,
	"./te.js": 205,
	"./tet": 206,
	"./tet.js": 206,
	"./tg": 207,
	"./tg.js": 207,
	"./th": 208,
	"./th.js": 208,
	"./tk": 209,
	"./tk.js": 209,
	"./tl-ph": 210,
	"./tl-ph.js": 210,
	"./tlh": 211,
	"./tlh.js": 211,
	"./tr": 212,
	"./tr.js": 212,
	"./tzl": 213,
	"./tzl.js": 213,
	"./tzm": 214,
	"./tzm-latn": 215,
	"./tzm-latn.js": 215,
	"./tzm.js": 214,
	"./ug-cn": 216,
	"./ug-cn.js": 216,
	"./uk": 217,
	"./uk.js": 217,
	"./ur": 218,
	"./ur.js": 218,
	"./uz": 219,
	"./uz-latn": 220,
	"./uz-latn.js": 220,
	"./uz.js": 219,
	"./vi": 221,
	"./vi.js": 221,
	"./x-pseudo": 222,
	"./x-pseudo.js": 222,
	"./yo": 223,
	"./yo.js": 223,
	"./zh-cn": 224,
	"./zh-cn.js": 224,
	"./zh-hk": 225,
	"./zh-hk.js": 225,
	"./zh-mo": 226,
	"./zh-mo.js": 226,
	"./zh-tw": 227,
	"./zh-tw.js": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_apis__ = __webpack_require__(20);







__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin({
  data: function data() {
    return {};
  },

  methods: {
    checkDevice: function checkDevice() {
      // production
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var platform = navigator.platform.toLowerCase();
        if (platform !== '' && platform.search('win') === -1 && platform.search('mac') === -1) {
          return true;
        }
        return false;
      }
      return false;

      // development
      // return true
    },
    checkOAuth: function checkOAuth() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var jwt, current_time, expire_time;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.checkDevice() === true)) {
                  _context.next = 24;
                  break;
                }

                if (!(localStorage.refresh_token !== undefined)) {
                  _context.next = 21;
                  break;
                }

                if (!(localStorage.access_token !== undefined)) {
                  _context.next = 16;
                  break;
                }

                jwt = Object(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__["a" /* default */])(localStorage.access_token);

                if (!(jwt !== null)) {
                  _context.next = 12;
                  break;
                }

                current_time = parseInt(new Date().getTime() / 1000);
                expire_time = parseInt(jwt.expire);

                if (!(current_time > expire_time)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return _this.getRefreshToken();

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.next = 14;
                return _this.getRefreshToken();

              case 14:
                _context.next = 18;
                break;

              case 16:
                _context.next = 18;
                return _this.getRefreshToken();

              case 18:
                if (_this.$route.name === 'login') {
                  window.location = '/checkin';
                }
                _context.next = 22;
                break;

              case 21:
                _this.logOut();

              case 22:
                _context.next = 25;
                break;

              case 24:
                _this.$router.push('/error').catch(function () {});

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRefreshToken: function getRefreshToken() {
      var _this2 = this;

      this.$store.state.is_loading = true;
      __WEBPACK_IMPORTED_MODULE_5__models_apis__["a" /* default */].OAuth(this.$store.state.api_url, { agent: navigator.userAgent + ' Platform: ' + navigator.platform }, { headers: { 'Access-Token': '' + localStorage.refresh_token } }, function (result) {
        if (result.response === true) {
          localStorage.access_token = result.access_token;
          _this2.$store.state.is_loading = false;
        } else {
          _this2.$store.state.is_loading = false;
          _this2.logOut();
        }
      }, function (error) {
        _this2.$store.state.is_loading = false;
        _this2.logOut();
        console.log(error);
      });
    },
    logOut: function logOut() {
      var _this3 = this;

      if (this.$route.name !== 'login') {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
          title: 'ไม่สามารถทำรายการได้',
          text: 'เซสชั่นหมดอายุ เข้าสู่ระบบใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonColor: '#F43131',
          confirmButtonText: 'เข้าสู่ระบบ',
          showCancelButton: false,
          allowOutsideClick: false
        }).then(function (result) {
          if (result.isConfirmed) {
            localStorage.clear();
            _this3.$router.push('/login').catch(function () {});
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {
    // console.log(navigator)
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.$store.state.screen_height = window.innerHeight;
      this.$store.state.screen_width = window.innerWidth;
    }
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      contact: {},
      appCode: ''
    };
  },
  created: function created() {
    this.checkOAuth();
    this.getContact();
    this.appCode = navigator.platform;
  },
  mounted: function mounted() {
    $('#form-login').removeClass('was-validated');
  },

  methods: {
    getContact: function getContact() {
      var _this = this;

      this.$store.state.is_loading = true;
      __WEBPACK_IMPORTED_MODULE_0__models_apis__["a" /* default */].getContact(this.$store.state.api_url, { headers: { 'Access-Token': this.$store.state.public_token } }, function (result) {
        if (result.response === true) {
          _this.contact = result.data;
        }
        _this.$store.state.is_loading = false;
      }, function (error) {
        _this.$store.state.is_loading = false;
        console.log(error.message);
      });
    },
    checkForm: function checkForm() {
      var $form_data = $('#form-login');
      if (!$form_data[0].checkValidity()) {
        $('#form-login').addClass('was-validated');
      } else {
        this.authLogin();
      }
    },
    authLogin: function authLogin() {
      var _this2 = this;

      this.$store.state.is_loading = true;
      var obj = {
        username: this.username,
        password: this.password,
        agent: navigator.userAgent + ' Platform: ' + navigator.platform
      };
      __WEBPACK_IMPORTED_MODULE_0__models_apis__["a" /* default */].Login(this.$store.state.api_url, obj, { headers: { 'Access-Token': this.$store.state.public_token } }, function (result) {
        if (result.response === true) {
          localStorage.refresh_token = result.refresh_token;
          _this2.$store.state.is_loading = false;
          window.location = '/checkin';
        } else {
          _this2.$store.state.is_loading = false;
          _this2.unSuccess(result.message);
        }
      }, function (error) {
        _this2.$store.state.is_loading = false;
        _this2.unSuccess(error.message);
      });
    },
    unSuccess: function unSuccess(message) {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
        title: 'เกิดข้อผิดพลาดบางอย่าง',
        text: message,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'ลองใหม่อีกครั้ง',
        showCancelButton: false,
        allowOutsideClick: false
      }).then(function (result) {});
    }
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_barcodeView__ = __webpack_require__(302);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkin',
  components: {
    barcodeView: __WEBPACK_IMPORTED_MODULE_7__components_barcodeView__["a" /* default */]
  },
  data: function data() {
    return {
      loop_location: '',
      area_list: [],
      area_use: [],
      area_use_id: 99,
      area_use_name: '---',
      recent_checkin: [],
      text_checkin: 'ลงเวลาปฏิบัติงาน',
      zoom: 15,
      location: {
        lat: 0,
        long: 0
      },
      center: {
        lat: 0,
        long: 0
      },
      type: 1,
      is_allow: false,
      is_real_location: false,
      user: {
        instructor_id: '',
        campus_id: '',
        fingerprint_id: '',
        fullname: '---',
        position: '---',
        image: '/static/img/nouser.jpg',
        wfh_allow: 0
      },
      sound_notification: null
    };
  },
  created: function created() {
    this.checkOAuth();
    this.initData();
  },
  destroyed: function destroyed() {
    clearInterval(this.loop_location);
  },
  mounted: function mounted() {
    // let platform = navigator.platform
    // this.$modal.show('alert_modal')
  },

  methods: {
    cardGenerator: function cardGenerator() {
      this.$modal.show('card_modal');
    },
    deviceInfo: function deviceInfo() {
      this.$modal.show('info_modal');
    },

    // init
    initData: function initData() {
      var _this = this;

      setTimeout(function () {
        if (navigator.geolocation) {
          _this.setUser();
          _this.getAreaList();
          _this.getRecentCheckin();
          _this.setLoop();
          _this.sound_notification = new Audio('../../static/sound/notification.mp3');
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: 'เกิดข้อผิดพลาดบางอย่าง',
            text: 'ไม่สามารถเข้าถึงตำแหน่งของอุปกรณ์นี้ได้ ลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            showCancelButton: false,
            allowOutsideClick: false
          }).then(function (result) {
            if (result.isConfirmed) {
              _this.reLoad();
            }
          });
        }
      }, 1000);
    },

    // user
    setUser: function setUser() {
      var jwt = Object(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__["a" /* default */])(localStorage.access_token);
      if (jwt !== null) {
        this.user = {
          instructor_id: jwt.instructor_id,
          campus_id: jwt.campus_id,
          fingerprint_id: jwt.fingerprint_id,
          fullname: jwt.fullname,
          card_id: jwt.card_id,
          position: jwt.position,
          image: jwt.image,
          wfh_allow: jwt.wfh_allow
        };
      }
    },

    // area list
    getAreaList: function getAreaList() {
      var _this2 = this;

      this.$store.state.is_loading = true;
      __WEBPACK_IMPORTED_MODULE_5__models_apis__["a" /* default */].getAreaList(this.$store.state.api_url, { headers: { 'Access-Token': '' + localStorage.access_token } }, function (result) {
        if (result.response === true) {
          _this2.area_list = result.data;
          _this2.area_list.forEach(function (row) {
            row.distance = 0;
            row.rad_color = '#f78b83';
          });
          _this2.getLocation();
        }
        _this2.$store.state.is_loading = false;
      }, function (error) {
        _this2.$store.state.is_loading = false;
        console.log(error);
      });
    },

    // recent checkin
    getRecentCheckin: function getRecentCheckin() {
      var _this3 = this;

      this.$store.state.is_loading = true;
      __WEBPACK_IMPORTED_MODULE_5__models_apis__["a" /* default */].getRecentCheckin(this.$store.state.api_url, { headers: { 'Access-Token': '' + localStorage.access_token } }, function (result) {
        if (result.response === true) {
          _this3.recent_checkin = result.data;
        }
        _this3.$store.state.is_loading = false;
      }, function (error) {
        _this3.$store.state.is_loading = false;
        console.log(error);
      });
    },

    // loop interval
    setLoop: function setLoop() {
      var _this4 = this;

      this.loop_location = setInterval(function () {
        _this4.getLocation();
      }, 3000);
    },
    getLocation: function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.calculateAreaDistance);
      }
      var date = new Date();
      // let day = date.getDate()
      var hour = date.getHours();
      var minute = date.getMinutes();
      // let second = date.getSeconds()
      if (hour >= 16 && minute >= 30) {
        this.text_checkin = 'ลงเวลาออกงาน';
      } else {
        this.text_checkin = 'ลงเวลาเข้างาน';
      }
    },

    // calculate area distance
    calculateAreaDistance: function calculateAreaDistance(position) {
      var _this5 = this;

      // location
      this.location.lat = parseFloat(position.coords.latitude);
      this.location.long = parseFloat(position.coords.longitude);
      // center
      if (this.center.lat === 0 && this.center.long === 0) {
        this.center.lat = this.location.lat;
        this.center.long = this.location.long;
      }
      if (this.area_list.length > 0) {
        this.area_list.forEach(function (row) {
          row.distance = _this5.calculateDistance({
            lat: _this5.location.lat,
            long: _this5.location.long
          }, {
            lat: row.area_lat,
            long: row.area_long
          });
        });
        this.area_list.sort(function (a, b) {
          return parseInt(a['distance']) - parseInt(b['distance']);
        });
        this.area_use = this.area_list[0];
        this.checkAreaUse();
      }
    },
    calculateDistance: function calculateDistance(p1, p2) {
      var R = 6378137;
      var calLat = this.calculateRadius(p2.lat - p1.lat);
      var calLong = this.calculateRadius(p2.long - p1.long);
      var a = Math.sin(calLat / 2) * Math.sin(calLat / 2) + Math.cos(this.calculateRadius(p1.lat)) * Math.cos(this.calculateRadius(p2.lat)) * Math.sin(calLong / 2) * Math.sin(calLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return Math.ceil(d);
    },
    calculateRadius: function calculateRadius(x) {
      return x * Math.PI / 180;
    },

    // check area use
    checkAreaUse: function checkAreaUse() {
      var _this6 = this;

      var check = this.calculateInArea({
        lat: this.location.lat,
        long: this.location.long
      }, {
        lat: this.area_use.area_lat,
        long: this.area_use.area_long,
        rad: this.area_use.area_limit / 1000
      });
      if (check === true) {
        this.area_list.forEach(function (row) {
          if (row.area_id === _this6.area_use.area_id) {
            row.rad_color = '#a7f5a4';
            _this6.area_use_id = _this6.type === 1 ? _this6.area_use.area_id : 99;
            _this6.area_use_name = _this6.type === 1 ? row.area_name : '---';
          } else {
            row.rad_color = '#f78b83';
          }
        });
      } else {
        this.area_use_id = 99;
        this.area_use_name = '---';
      }
      this.allowCheckin();
    },
    calculateInArea: function calculateInArea(p1, p2) {
      var ky = 40000 / 360;
      var kx = Math.cos(Math.PI * p2.lat / 180.0) * ky;
      var dx = Math.abs(p2.long - p1.long) * kx;
      var dy = Math.abs(p2.lat - p1.lat) * ky;
      return Math.sqrt(dx * dx + dy * dy) <= p2.rad;
    },
    reCenter: function reCenter() {
      var rand = Math.random() * 0.0000001;
      this.center.lat = this.location.lat + rand;
      this.center.long = this.location.long + rand;
      this.zoom = 15;
    },
    reLoad: function reLoad() {
      location.reload();
    },

    // switch type
    switchType: function switchType() {
      // 1 RMUTL
      // 2 WFH
      if (this.type === 1) {
        if (parseInt(this.user.wfh_allow) === 1) {
          this.type = 2;
        } else {
          // this.soundNotification()
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: 'ฟังก์ชั่นนี้ถูกปิดใช้งาน',
            text: 'ขณะนี้ไม่สามารถปฏิบัติงานที่บ้านได้',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'รับทราบ',
            showCancelButton: false,
            allowOutsideClick: false
          }).then(function (result) {
            if (result.isConfirmed) {}
          });
        }
      } else {
        this.type = 1;
      }
      this.is_allow = false;
      this.area_use_id = 99;
      this.area_use_name = '---';
      this.checkAreaUse();
    },

    // check allow
    allowCheckin: function allowCheckin() {
      this.is_allow = false;
      if (this.location.lat !== 0 && this.location.long !== 0) {
        if (this.type === 2) {
          this.is_allow = true;
        } else {
          if (this.area_use_id !== 99) {
            this.is_allow = true;
          }
        }
      }
    },
    checkIn: function checkIn() {
      var _this7 = this;

      if (this.is_allow === true) {
        this.$store.state.is_loading = true;
        var obj = {
          area_id: this.area_use_id,
          type: this.type,
          lat: this.location.lat,
          long: this.location.long
        };
        __WEBPACK_IMPORTED_MODULE_5__models_apis__["a" /* default */].addCheckin(this.$store.state.api_url, obj, { headers: { 'Access-Token': '' + localStorage.access_token } }, function (result) {
          if (result.response === true) {
            // this.soundNotification()
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
              title: 'ทำรายการสำเร็จ',
              text: _this7.text_checkin + 'เรียบร้อยแล้ว',
              icon: 'success',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'รับทราบ',
              showCancelButton: false,
              allowOutsideClick: false
            }).then(function (result) {
              if (result.isConfirmed) {
                _this7.getRecentCheckin();
              }
            });
          } else {
            _this7.unSuccess();
          }
          _this7.$store.state.is_loading = false;
        }, function (error) {
          _this7.$store.state.is_loading = false;
          console.log(error);
          _this7.unSuccess();
        });
      }
    },
    unSuccess: function unSuccess() {
      var _this8 = this;

      // this.soundNotification()
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: 'เกิดข้อผิดพลาดบางอย่าง',
        text: 'ข้อมูลเช็คอินไม่ถูกต้อง ลองใหม่อีกครั้ง',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'ลองใหม่อีกครั้ง',
        showCancelButton: false,
        allowOutsideClick: false
      }).then(function (result) {
        if (result.isConfirmed) {
          _this8.reLoad();
        }
      });
    },
    soundNotification: function soundNotification() {
      if (this.sound_notification) {
        this.sound_notification.play();
        setTimeout(function () {
          this.sound_notification.pause();
          this.sound_notification.currentTime = 0;
        }, 1000);
      }
    },

    // check fake location
    checkFakeLocation: function checkFakeLocation() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var location_check, i, position, location_check_;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!navigator.geolocation) {
                  _context.next = 14;
                  break;
                }

                _this9.is_real_location = false;
                location_check = [];
                i = 0;

              case 4:
                if (!(i < 5)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 7;
                return _this9.getFakeLocation(i);

              case 7:
                position = _context.sent;

                location_check.push({ lat: position.coords.latitude, long: position.coords.longitude });

              case 9:
                i++;
                _context.next = 4;
                break;

              case 12:
                if (location_check.length === 5) {
                  location_check_ = location_check.map(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a).reverse().filter(function (item, index, arr) {
                    return arr.indexOf(item, index + 1) === -1;
                  }).reverse().map(JSON.parse);

                  if (location_check_.length > 3) {
                    _this9.is_real_location = true;
                  }
                }
                if (_this9.is_real_location === false) {
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    title: 'ตรวจพบการปลอมแปลงตำแหน่ง',
                    text: 'ปิดใช้งานซอฟต์แวร์ปลอมแปลงตำแหน่ง แล้วลองใหม่อีกครั้ง',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'ลองใหม่อีกครั้ง',
                    showCancelButton: false,
                    allowOutsideClick: false
                  }).then(function (result) {
                    if (result.isConfirmed) {
                      _this9.reLoad();
                    }
                  });
                }

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    getFakeLocation: function getFakeLocation() {
      var options = {
        enableHighAccuracy: false,
        timeout: 3000,
        maximumAge: 0
      };
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return setTimeout(function () {
          navigator.geolocation.getCurrentPosition(resolve, reject, options);
        }, 300);
      });
    }
  }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_barcode__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'barcodeView',
  props: ['id_card'],
  components: {
    barcode: __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default.a
  },
  data: function data() {
    return {};
  },
  created: function created() {
    // console.log(this.id_card)
  },
  mounted: function mounted() {
    // console.log(this.id_card)
  },

  methods: {}
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      if (_this.checkDevice() === true) {
        window.location = '/login';
      } else {
        _this.$router.push('/error').catch(function () {});
      }
    }, 1000);
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a42f162.png";

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_apis__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      contact: {},
      show_device_info: 1,
      device_info: {
        platform: '',
        useragent: ''
      }
    };
  },
  created: function created() {
    this.getContact();
  },
  mounted: function mounted() {},

  methods: {
    showDeviceInfo: function showDeviceInfo() {
      this.device_info.platform = navigator.platform;
      this.device_info.useragent = navigator.userAgent;
      this.show_device_info = this.show_device_info === 1 ? 2 : 1;
    },
    getContact: function getContact() {
      var _this = this;

      this.$store.state.is_loading = true;
      __WEBPACK_IMPORTED_MODULE_0__models_apis__["a" /* default */].getContact(this.$store.state.api_url, { headers: { 'Access-Token': this.$store.state.public_token } }, function (result) {
        if (result.response === true) {
          _this.contact = result.data;
        }
        _this.$store.state.is_loading = false;
      }, function (error) {
        _this.$store.state.is_loading = false;
        console.log(error.message);
      });
    },
    goLogin: function goLogin() {
      localStorage.clear();
      this.$router.push('/login').catch(function () {});
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

module.exports = {"last_update":"2024-02-29T01:52:30.394Z","api_url":"https://checkin.rmutl.ac.th/api/","ui_url":"https://checkin.rmutl.ac.th/ui","public_token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiY2hlY2tpbl9ybXV0bCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMS0xMS0wNSAxMzo0MDoyMSJ9.HAxY5B7nmuY5cTcXwOmQdWVl-i8paSBB-3Z5jyZRCsU"}

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(358)));

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(362)));

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(366)));

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(371)));

/***/ })

},[228]);


// WEBPACK FOOTER //
// static/js/app.002aab3d0c55adf78502.js